import RequestAbstract from "../abstract";

export default class AccountingExternalTransactions extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/accounting-external-transactions";
    }

}
